import React from 'react';
import PropTypes from 'prop-types';
import {utils, writeFile} from 'xlsx';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData, formatDate, ExcelDateToDateString} from "../../globals/GlobalFunctions";

export interface Props {
    excelData: any;
}

//fixed width accum format
function EHIMAccumFormatter ({excelData}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    try{
        //Check for 2 sheets here
        if (!isEmpty(excelData) && excelData.Sheets.EHIMAccum !== undefined) {
            let accumSheetDataArray = extractWorkSheetData(excelData.Sheets.EHIMAccum);

            let accumRawCellArray: any[] = accumSheetDataArray[0];

            let accumColumnRange: number = accumSheetDataArray[1];

            let accumRowRange: number = accumSheetDataArray[2];

            const accumValuesIndexCollection = {
                subscriberIndex: accumRawCellArray.indexOf('Subscriber_ID') + 1,
                groupIndex: accumRawCellArray.indexOf('Group_ID') + 1,
                seqIndex: accumRawCellArray.indexOf('Member_Seq') + 1,
                oopIndex: accumRawCellArray.indexOf('Out_Of_Pocket') + 1,
                deducIndex: accumRawCellArray.indexOf('Deductible_Used') + 1,
                fromDateIndex: accumRawCellArray.indexOf('From_Date') + 1,
            }

            let arrayOfMemberArrays: any[] = [];

            for (let i = 1; i < accumRowRange; i++) {
                //our member to later be pushed. Oh from what humble origins it begins
                let memberArray: any[] = [];
                //out of pocket
                let oopMemberString: string = "";
                //deductable
                let deducMemberString: string = "";
                //for each new member array we skip over the previous members determined by the column length, removing 1 to account for our zero based index at the beginning
                let rowMultiplier = accumColumnRange * i - 1;

                if (accumValuesIndexCollection.groupIndex > 0) {
                    oopMemberString += (accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.groupIndex)].toString().padEnd(15, " "));
                    deducMemberString += (accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.groupIndex)].toString().padEnd(15, " "));
                } else {
                    oopMemberString += "               ";
                    deducMemberString += "               ";
                }

                if(accumValuesIndexCollection.subscriberIndex > 0){
                    oopMemberString += ((accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.subscriberIndex)].toString().padStart(9, "0") + "01").padEnd(20, " "));
                    deducMemberString += ((accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.subscriberIndex)].toString().padStart(9, "0")  + "01").padEnd(20, " "));
                }

                if (accumValuesIndexCollection.seqIndex > 0) {
                    oopMemberString += accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.seqIndex)].toString().padStart(3, "0");
                    deducMemberString += accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.seqIndex)].toString().padStart(3, "0");
                }

                //two strings per member to track each value
                oopMemberString += " ";
                deducMemberString += " ";

                if (accumValuesIndexCollection.oopIndex > 0) {
                    oopMemberString += Number(accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.oopIndex)])
                        .toFixed(2).toString().replace(/\./g, "").padStart(9, "0");
                }

                if (accumValuesIndexCollection.deducIndex > 0) {
                    deducMemberString += Number(accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.deducIndex)])
                        .toFixed(2).toString().replace(/\./g, "").padStart(9, "0");
                }

                if (accumValuesIndexCollection.fromDateIndex > 0) {
                    let date = accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.fromDateIndex)].toString();
                    if (date.includes("/")) {
                        date = formatDate(date);
                    } else if (date.length > 0 && date.length < 6) {
                        date = ExcelDateToDateString(date);
                    }
                    if (date.length > 7) {
                        date = date.replace(/-/g, "");
                    }
                    oopMemberString += date;
                    deducMemberString += date;
                } else {
                    oopMemberString += "        ";
                    deducMemberString += "        ";
                }

                oopMemberString += "O";
                deducMemberString += "D";

                //only add nonzero accums to file
                if (Number(accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.oopIndex)]) > 0){
                    memberArray.push(oopMemberString);
                    arrayOfMemberArrays.push(memberArray);
                    memberArray = [];
                }

                if (Number(accumRawCellArray[(rowMultiplier + accumValuesIndexCollection.deducIndex)]) > 0){
                    memberArray.push(deducMemberString);
                    arrayOfMemberArrays.push(memberArray);
                    memberArray = [];
                }

            }

            arrayOfMemberArrays.push([""]);

            //create our workbook
            const eligWorkbook = utils.book_new();
            //make the member sheet from our member array of arrays
            let ws1 = utils.aoa_to_sheet(arrayOfMemberArrays, {dateNF: 'mm.dd.yyyy'});

            const today = new Date();

            const month = today.getMonth() + 1;

            let monthString = "";

            let dayString = "";

            if(month < 10){
                monthString = "0" + month.toString();
            }
            else{
                monthString = month.toString();
            }

            const day = today.getDate();

            if(day < 10) {
                dayString = "0" + day.toString();
            }
            else {
                dayString = day.toString();
            }

            const year = today.getFullYear();

            //add it to the new workbook
            utils.book_append_sheet(eligWorkbook, ws1, "CASEHIM_Accum_" + monthString + dayString + year + " VBA");
            //it exists and has a sheet send it back to app for export
            if (eligWorkbook && eligWorkbook.SheetNames.includes("CASEHIM_Accum_" + monthString + dayString + year + " VBA")) {
                if (!eligWorkbook.Props) eligWorkbook.Props = {};

                //setting the workbook title through props
                eligWorkbook.Props.Title = "CASEHIM_Accum_" + monthString + dayString + year + " VBA.txt";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(eligWorkbook, "CASEHIM_Accum_" + monthString + dayString + year + " VBA.txt", {});

                console.log("File Export Complete!");
                setSuccessAlert(true);
            } else {
                setErrorAlert(true);
                console.log("Unknown Export Error!");
            }

            //clear it out at the end in case of rerendering
            excelData.Sheets.EHIMAccum = undefined;
        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.EHIMAccum = undefined;

    }
    return (
        <div>
            {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                File Download Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
        </div>
    );
}


export default React.memo(EHIMAccumFormatter)

EHIMAccumFormatter.propTypes = {
    excelData: PropTypes.object.isRequired,
};